import React, { useEffect } from 'react';
import { Col, Spinner } from 'react-bootstrap';

import { useWelcome } from './useWelcome';

import classes from './Welcome.module.scss';

export const Welcome = () => {
  const {
    showErrorNotification,
    isLoading,
    loginWithRedirect,
    isAuthenticated,
    error
  } = useWelcome();

  // Start the login redirect as soon as the Auth0 SDK has settled and confirmed there is no
  // existing session. This replaces a fixed 1500ms timer that raced the SDK: logged-out users
  // always paid the full delay, and logged-in users on slow connections could lose the race and
  // get bounced through Auth0 anyway. (Authenticated users are navigated to /dashboard by
  // useWelcome before this fires; an Auth0 error shows the notification instead of redirecting.)
  useEffect(() => {
    if (!isLoading && !isAuthenticated && !error) {
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, error, loginWithRedirect]);

  if (isLoading) {
    return (
      <Col xs={12}>
        <Spinner className="position-absolute start-50" animation="grow" />
      </Col>
    );
  }

  return (
    <>
      {showErrorNotification && (
        <div className={classes.errorNotification}>
          Something went wrong, please try again later
        </div>
      )}
    </>
  );
};
